import React, { Component } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import SimpleCheckBox from "../../../../modules/SimpleCheckBox";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import Api from "../../../../Services/Api";
import * as R from "ramda";
import {
  BARCODE_KEY_MAP,
  CATEGORY_MAP,
  CONFIG_DETAIL,
  Kode_KEY_MAP,
} from "../config";
import { hasNilOrEmpty, isNotNilAndEmpty } from "../../../../Services/Utils";
import { Scanner } from "@yudiel/react-qr-scanner";
import { defaultTableChange } from "../../../../modules/custom/customTable";

class EkspedisiDetailTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      failedQRAlertVisible: false,
      alertVisible: false,
      alertMessage: null,
      scanQRCodeVisible: false,
      selectedIndex: null,
      qrCode: null,
      isPdiScanned: false,
      tableColumns: this.getDetailTableColumns(props.tab, props.lists),
      tableColumnsNoQR: this.getDetailTableColumnsNoQR(props.tab, props.lists),
      pagination: {
        count: 10,
        limit: 5,
        page: 1,
        orderBy: "id",
        sort: "ASC",
      },
      paginationQR: {
        limit: 5,
        page: 1,
      },
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.lists !== this.props.lists) {
      this.setState({
        tableColumns: this.getDetailTableColumns(
          this.props.tab,
          this.props.lists,
        ),
        tableColumnsNoQR: this.getDetailTableColumnsNoQR(
          this.props.tab,
          this.props.lists,
        ),
      });
    }
  }

  getDetailTableColumns = (tab, lists) => {
    const {
      actionType,
      editingRow,
      tab: parentTab,
      onEditRow,
      onSaveRow,
      onDeleteRow,
      handleValueChange,
      handleSelectChange,
      dataTable,
      dataTableNoQR,
      isAddingRow,
    } = this.props;

    let columns = [
      ...CONFIG_DETAIL.TABLE_COLUMN(
        tab,
        actionType,
        handleValueChange,
        handleSelectChange,
        lists,
        false,
        dataTable,
        dataTableNoQR,
        isAddingRow,
        editingRow,
      ),
    ];

    columns.push({
      name: "action",
      label: "Scan / Menyusul",
      options: {
        customBodyRender: (_, tableMeta) => {
          const { dataTable, selectedData, isMenyusul } = this.props;
          const rowIndex = tableMeta.rowIndex;
          const isDisabled =
            selectedData.statusEkspedisi !== "DRAFT" &&
            (!isMenyusul || Boolean(dataTable[rowIndex][BARCODE_KEY_MAP[tab]]));

          return (
            <FlexView
              vAlignContent="center"
              className="margin-bottom-10px"
              style={{ gap: "10px" }}
            >
              <SimpleButton
                type="button"
                category="action_button"
                icon={<i className="fa fa-qrcode"></i>}
                onClick={() => {
                  this.handleScanQRCodeVisibility(rowIndex);
                  this.handleSubmitMenyusul(false, rowIndex);
                }}
                disabled={isDisabled}
              />
              <SimpleCheckBox
                id={`checkbox_menyusul_${rowIndex}`}
                checked={dataTable[rowIndex]?.menyusul || false}
                disabled={isDisabled}
                onChange={(e) =>
                  this.handleSubmitMenyusul(e.target.checked, rowIndex)
                }
              />
            </FlexView>
          );
        },
        options: { sort: false },
      },
    });

    if (this.props.tabParent === "BELUM_EKSPEDISI") {
      columns.push({
        name: "rowActions",
        label: "Aksi",
        options: {
          sort: false,
          customBodyRender: (_, tableMeta) => {
            const rowData = this.props.dataTable[tableMeta.rowIndex];
            if (!rowData) return null;

            const isDisabledAction =
              actionType === "proses" && rowData?.source === "SALES_ORDER";

            const isEditing =
              editingRow &&
              editingRow.tab === parentTab &&
              editingRow.rowIndex === tableMeta.rowIndex;

            const isSaved = rowData?.action?.saved ?? false;
            const showEditMode = isEditing || !isSaved;

            return (
              <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                {showEditMode ? (
                  <>
                    <SimpleButton
                      type="button"
                      category="action_button"
                      icon={
                        <i
                          className="fa fa-save"
                          style={{ fontSize: 20, color: "red" }}
                        />
                      }
                      onClick={() => onSaveRow(parentTab, tableMeta.rowIndex)}
                      disabled={isDisabledAction}
                    />

                    <SimpleButton
                      type="button"
                      category="action_button"
                      icon={
                        <i
                          className="fa fa-trash"
                          style={{
                            fontSize: 20,
                            color: isDisabledAction ? "black" : "red",
                          }}
                        />
                      }
                      onClick={() => onDeleteRow(tableMeta.rowIndex, parentTab)}
                      disabled={isDisabledAction}
                    />
                  </>
                ) : (
                  <>
                    <SimpleButton
                      type="button"
                      category="action_button"
                      icon={
                        <i
                          className="fa fa-pencil-alt"
                          style={{
                            fontSize: 20,
                            color: isDisabledAction ? "black" : "red",
                          }}
                        />
                      }
                      onClick={() => onEditRow(tableMeta.rowIndex, parentTab)}
                      disabled={isDisabledAction}
                    />

                    <SimpleButton
                      type="button"
                      category="action_button"
                      icon={
                        <i
                          className="fa fa-trash"
                          style={{
                            fontSize: 20,
                            color: isDisabledAction ? "black" : "red",
                          }}
                        />
                      }
                      onClick={() => onDeleteRow(tableMeta.rowIndex, parentTab)}
                      disabled={isDisabledAction}
                    />
                  </>
                )}
              </FlexView>
            );
          },
        },
      });
    }

    return columns;
  };

  getDetailTableColumnsNoQR = (tab, lists) => {
    const {
      actionType,
      editingRow,
      tab: parentTab,
      onEditRowNoQR,
      onSaveRowNoQR,
      onDeleteRowNoQR,
      handleValueChange,
      handleSelectChange,
      dataTable,
      dataTableNoQR,
      isAddingRow,
    } = this.props;

    let columns = [
      ...CONFIG_DETAIL.TABLE_COLUMN(
        tab,
        actionType,
        handleValueChange,
        handleSelectChange,
        lists,
        true,
        dataTable,
        dataTableNoQR,
        isAddingRow,
        editingRow,
      ),
    ];

    columns.pop();
    columns.push(
      CONFIG_DETAIL.TABLE_COLUMN_ADDITIONAL(
        tab,
        actionType,
        handleValueChange,
        editingRow,
        dataTableNoQR,
      ),
    );

    if (this.props.tabParent === "BELUM_EKSPEDISI") {
      columns.push({
        name: "rowActions",
        label: "Aksi",
        options: {
          sort: false,
          customBodyRender: (_, tableMeta) => {
            const rowData = this.props.dataTableNoQR[tableMeta.rowIndex];
            if (!rowData) return null;

            const isDisabledAction =
              actionType === "proses" && rowData?.source === "SALES_ORDER";

            const isEditing =
              editingRow &&
              editingRow.tab === parentTab &&
              editingRow.rowIndex === tableMeta.rowIndex;

            const isSaved = rowData?.action?.saved ?? false;
            const showEditMode = isEditing || !isSaved;

            return (
              <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                {showEditMode ? (
                  <>
                    {/* Tombol Save */}
                    <SimpleButton
                      type="button"
                      category="action_button"
                      icon={
                        <i
                          className="fa fa-save"
                          style={{ fontSize: 20, color: "red" }}
                        />
                      }
                      onClick={() =>
                        onSaveRowNoQR(parentTab, tableMeta.rowIndex)
                      }
                      disabled={isDisabledAction}
                    />

                    {/* Tombol Delete */}
                    <SimpleButton
                      type="button"
                      category="action_button"
                      icon={
                        <i
                          className="fa fa-trash"
                          style={{
                            fontSize: 20,
                            color: isDisabledAction ? "black" : "red",
                          }}
                        />
                      }
                      onClick={() =>
                        onDeleteRowNoQR(parentTab, tableMeta.rowIndex)
                      }
                      disabled={isDisabledAction}
                    />
                  </>
                ) : (
                  <>
                    {/* Tombol Edit */}
                    <SimpleButton
                      type="button"
                      category="action_button"
                      icon={
                        <i
                          className="fa fa-pencil-alt"
                          style={{
                            fontSize: 20,
                            color: isDisabledAction ? "black" : "red",
                          }}
                        />
                      }
                      onClick={() =>
                        onEditRowNoQR(tableMeta.rowIndex, parentTab)
                      }
                      disabled={isDisabledAction}
                    />

                    {/* Tombol Delete */}
                    <SimpleButton
                      type="button"
                      category="action_button"
                      icon={
                        <i
                          className="fa fa-trash"
                          style={{
                            fontSize: 20,
                            color: isDisabledAction ? "black" : "red",
                          }}
                        />
                      }
                      onClick={() =>
                        onDeleteRowNoQR(parentTab, tableMeta.rowIndex)
                      }
                      disabled={isDisabledAction}
                    />
                  </>
                )}
              </FlexView>
            );
          },
        },
      });
    }

    return columns;
  };

  handleScanQRCodeVisibility = (index) => {
    this.setState((prevState) => ({
      selectedIndex: index,
      scanQRCodeVisible: !prevState.scanQRCodeVisible,
    }));
  };

  handleScanQR = async (data) => {
    const barcodeFromScan = data[0].rawValue;
    const { selectedIndex } = this.state;
    const { dataTable, tab, selectedCabang } = this.props;

    const itemCode = dataTable[selectedIndex][Kode_KEY_MAP[tab]];
    const barcode = dataTable[selectedIndex][BARCODE_KEY_MAP[tab]];

    const request = {
      nameCategory: CATEGORY_MAP[tab],
      encryptBarcode: barcodeFromScan,
      kodeCabang: selectedCabang?.value,
      trxType: "TRX_IN",
      codeItem: itemCode,
    };

    const res = await Api.create(
      "NAGAMAS_TRANSACTION",
    ).findBarcodeKsuBrlHdhMutation(request);

    if (res.ok) {
      const barcodeFromDB = res.data.data?.barcode;
      const itemCodeFromDB = res.data.data?.kodeItem;

      if (
        (isNotNilAndEmpty(itemCode, itemCodeFromDB) &&
          !R.equals(itemCode, itemCodeFromDB)) ||
        hasNilOrEmpty(itemCode, itemCodeFromDB)
      ) {
        this.handleFailedQRAlertVisibility();
        this.handleScanQRCodeVisibility();
        return;
      }

      if (
        isNotNilAndEmpty(barcode, barcodeFromDB) &&
        !R.equals(barcode, barcodeFromDB)
      ) {
        this.handleAlertVisibility(
          "QR Code sudah di scan dengan QR code berbeda. Apakah ingin update?",
        );
        return;
      }

      this.handleSubmitScanQR(barcodeFromDB);
    }
  };

  handleSubmitScanQR = (barcodeFromDB) => {
    const { selectedIndex } = this.state;
    const { tab, onChangeActionQRCode } = this.props;
    onChangeActionQRCode(selectedIndex, barcodeFromDB, tab);
    this.handleScanQRCodeVisibility();
  };

  handleSubmitMenyusul = (value, index) => {
    const row = this.props.dataTable[index];
    const isPdiScanned =
      [row?.ksuBarcode, row?.giftBarcode, row?.otherItemBarcode, row?.partBarcode]
          .some(barcode => barcode != null) &&
          !row?.menyusul;

    this.setState({ isPdiScanned });
    
    if (isPdiScanned) {
      this.handleAlertVisibility(
          "Menyusul tidak dapat dilakukan, karena proses Scan sudah dilakukan.",
        );
    } else {
      this.props.onChangeActionMenyusul(index, value, this.props.tab);
    }
  };

  handleSubmitMenyusulNoQr = (value, index) => {
    this.props.onChangeActionNoQRMenyusul(index, value, this.props.tab);
  };

  handleAlertVisibility = (text) => {
    this.setState((prev) => ({
      alertVisible: !prev.alertVisible,
      alertMessage: text,
    }));
  };

  handleFailedQRAlertVisibility = () => {
    this.setState((prev) => ({
      failedQRAlertVisible: !prev.failedQRAlertVisible,
    }));
  };

  handleChangePage = (tableState) => {
    this.setState((prevValue) => ({
        ...prevValue,
        pagination:{
            ...prevValue.pagination,
            page: tableState.page + 1,
        }
    }));
  };

  handleRowsPerPage = (tableState) => {
      this.setState((prevValue) => ({
          ...prevValue,
          pagination:{
              ...prevValue.pagination,
              page: 1,
              limit: tableState.rowsPerPage,
          }
      }));
  };
  
  handleChangePageQR = (tableState) => {
    this.setState((prevValue) => ({
        ...prevValue,
        paginationQR:{
            ...prevValue.paginationQR,
            page: tableState.page + 1,
        }
    }));
  };

  handleRowsPerPageQR = (tableState) => {
      this.setState((prevValue) => ({
          ...prevValue,
          paginationQR:{
              ...prevValue.paginationQR,
              page: 1,
              limit: tableState.rowsPerPage,
          }
      }));
  };

  render() {
    const {
      tab,
      dataTable,
      dataTableNoQR,
      onAddRowWithQR,
      onAddRowWithoutQR,
      tabParent,
    } = this.props;

    return (
      <>
        <FlexView column style={{ gap: 30, marginTop: 20 }}>
          <SimpleButton
            styles={{ marginLeft: 0 }}
            icon={<i className="fa fa-plus margin-right-10px"></i>}
            secondary={tabParent == "SUDAH_EKSPEDISI"}
            disabled={tabParent == "SUDAH_EKSPEDISI"}
            text="Tambah"
            onClick={() => onAddRowWithQR(tab)}
          />

          <Tabs>
            <TabList>
              <Tab>Dengan QR</Tab>
            </TabList>
            <TabPanel>
              <SimpleDataTable
                key={`${dataTable?.length}-${this.state.paginationQR.page}`}
                data={dataTable}
                columns={this.state.tableColumns}
                toCount={dataTable?.length}
                rowsPerPage={this.state.paginationQR.limit}
                page={this.state.paginationQR.page - 1}
                options={{...defaultTableChange(this.handleChangePageQR, this.handleRowsPerPageQR), serverSide: false}}
                handleValueChange={this.props.handleValueChange}
                tab={tab}
              />
            </TabPanel>
          </Tabs>

          {/* Tabel No QR */}
          {!R.equals(tab, "KSU") && (
            <>
              <SimpleButton
                styles={{ marginLeft: 0 }}
                icon={<i className="fa fa-plus margin-right-10px"></i>}
                text="Tambah"
                secondary={tabParent === "SUDAH_EKSPEDISI"}
                disabled={tabParent === "SUDAH_EKSPEDISI"}
                onClick={() => onAddRowWithoutQR(tab)}
              />

              <Tabs>
                <TabList>
                  <Tab>Tanpa QR</Tab>
                </TabList>
                <TabPanel>
                  <SimpleDataTable
                    key={`${dataTableNoQR?.length}-${this.state.pagination.page}`}
                    data={dataTableNoQR}
                    columns={this.state.tableColumnsNoQR}
                    toCount={dataTableNoQR?.length}
                    rowsPerPage={this.state.pagination.limit}
                    page={this.state.pagination.page - 1}
                    options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
                    handleValueChange={this.props.handleValueChange}
                    tab={tab}
                    isNoQR
                  />
                </TabPanel>
              </Tabs>
            </>
          )}
        </FlexView>

        {/* Scanner QR */}
        {this.state.scanQRCodeVisible && (
          <SimpleAlert
            title="Scan QR Here"
            visible={this.state.scanQRCodeVisible}
            onClickClose={this.handleScanQRCodeVisibility}
            content={
              <Scanner
                onScan={this.handleScanQR}
                constraints={{
                  height: { ideal: 720 },
                  video: {
                    facingMode: { exact: "environment" },
                    height: { ideal: 720 },
                  },
                }}
              />
            }
          />
        )}

        {/* Alerts */}
        {this.state.alertVisible && (
          <SimpleAlert
            visible={this.state.alertVisible}
            title="Information"
            onClickClose={this.handleAlertVisibility}
            content={
              <div>
                <p>{this.state.alertMessage}</p>
                <FlexView hAlignContent="center" style={{ marginTop: "10px" }}>
                  {!this.state.isPdiScanned ? (
                  <SimpleButton
                    text="Cancel"
                    onClick={() => {
                      this.handleScanQRCodeVisibility();
                      this.handleAlertVisibility();
                    }}
                  />) : null}
                  <SimpleButton
                    text="OK"
                    onClick={() => this.state.isPdiScanned ? this.handleAlertVisibility() : () => {
                      this.handleSubmitScanQR();
                      this.handleAlertVisibility();
                    }}
                  />
                </FlexView>
              </div>
            }
          />
        )}

        {this.state.failedQRAlertVisible && (
          <SimpleAlert
            visible={this.state.failedQRAlertVisible}
            title="Information"
            onClickClose={this.handleFailedQRAlertVisibility}
            content={
              <div>
                <p>Proses Scan QR Code Gagal. Barang tidak ditemukan.</p>
                <FlexView hAlignContent="center">
                  <SimpleButton
                    text="OK"
                    onClick={this.handleFailedQRAlertVisibility}
                  />
                </FlexView>
              </div>
            }
          />
        )}

        <SimpleLoadingOverlay active={this.state.loading} />
      </>
    );
  }
}

export default EkspedisiDetailTab;
